/**
 * Adds custom validations to the checkout form:
 * Provides a custom error message to the TOS checkbox
 */
export default function validateCheckoutForm() {
    Drupal.behaviors.showPassword = {
        attach: (context) => {
            const tosCheckbox = context.querySelector('#edit-terms-and-conditions') as HTMLInputElement;
            const submitButton = context.querySelector('#edit-submit') as HTMLInputElement;
            submitButton.addEventListener('click', (event) => {
                tosCheckbox.checkValidity();
                if (tosCheckbox.validity.valueMissing) {
                    const message = Drupal.t('viollier.shop.checkout.tos-error-message');
                    tosCheckbox.setCustomValidity(message);
                } else {
                    tosCheckbox.setCustomValidity('');
                }
            });
        },
    };
}

validateCheckoutForm();
